import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { GetUrlParams, PAGINATION_PARAMS } from '@lib/enums/urls';
import usePaginationParams from '@lib/hooks/usePaginationParams';

function useSearchParam({
  defaultSearch,
  defaultPaginationParams,
  usePagination = true,
}:
  | {
      defaultSearch?: string;
      defaultPaginationParams?: object;
      usePagination?: boolean;
    }
  | undefined = {}) {
  const [searchParam, setSearchParam] = useQueryParam(
    GetUrlParams.Search,
    withDefault(StringParam, defaultSearch),
  );
  const [, setPaginationParams] = usePaginationParams();
  const onSetSearchParam = (v: string, paginationParams?: object) => {
    setSearchParam(v);
    if (usePagination) {
      setPaginationParams({
        ...(paginationParams || defaultPaginationParams || PAGINATION_PARAMS),
        [GetUrlParams.Page]: '1',
      });
    }
  };
  return [searchParam, onSetSearchParam] as const;
}

export default useSearchParam;
